export enum ItemType {
  Auction = 'auction',
  Buynow = 'buynow',
  Giveaway = 'giveaway',
  Ticket = 'ticket',
  Donation = 'donation',
  CustomBuynow = 'customBuynow'
}
